import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux';
import { getReportCompletedActions, getReportCompletedActionsFailure, getReportCompletedActionsIdle, getReportCompletedActionsSuccess } from '../actions';

const status_get_report_completed_actions = handleActions(
  {
    [getReportCompletedActions.toString()]: (state, action) => 'LOADING',
    [getReportCompletedActionsSuccess.toString()]: (state, action) => 'SUCCESS',
    [getReportCompletedActionsFailure.toString()]: (state, action) => 'FAILURE',
    [getReportCompletedActionsIdle.toString()]: (state, action) => 'IDLE',
  },
  'IDLE'
);

const data_get_report_completed_actions = handleActions(
  {
    [getReportCompletedActions.toString()]: () => null,
    [getReportCompletedActionsSuccess.toString()]: (state, action) => action.payload,
    
  },
  null
);

export { status_get_report_completed_actions, data_get_report_completed_actions };
